module.exports = __webpack_public_path__ + "static/media/pawritten-bold.1d6f5612.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten-bold.eot
// module id = ./src/assets/fonts/pawritten-bold.eot
// module chunks = 0